import { IconStorage } from "@app/shared/icons/interfaces";

export const bookmarkAdd: IconStorage = {
  svgCode: () => ([
    "M19 21L12 16L5 21V6.2C5 5.0799 5 4.51984 5.21799 4.09202C5.40973 3.71569 5.71569 3.40973 6.09202 3.21799C6.51984 3 7.07989 3 8.2 3H15.8C16.9201 3 17.4802 3 17.908 3.21799C18.2843 3.40973 18.5903 3.71569 18.782 4.09202C19 4.51984 19 5.0799 19 6.2V21Z",
    "M12 8V13",
    "M9.5 10.5H14.5",
  ]),
};
